import React from 'react'
import { Box, Typography, Paper, useTheme, useMediaQuery } from '@mui/material'
import Logo from '../../assets/img/bctlogo.png'
import gradient from '../../assets/img/Pink-Purple-Gradient.png'
import transparentWave from '../../assets/img/Transparent-Wave.png'
import bctLogoWhite from '../../assets/img/lock-up-WHITE-OUT.png'

interface BusinessCardProps {
    title?: string
    firstName?: string
    lastName?: string
    institution?: string
    specialty?: string
    email?: string
    onClick?: () => void
    style?: React.CSSProperties
}

const BusinessCard: React.FC<BusinessCardProps> = ({
    title = 'TITLE',
    firstName = 'FIRST NAME',
    lastName = 'LAST NAME',
    institution = 'Institution',
    specialty = 'Specialty',
    email = 'Email Address',
    onClick,
    style
}) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down(650))
    const [isFlipped, setIsFlipped] = React.useState(false)

    return (
        <Box
            onClick={onClick}
            style={style}
            sx={{
                width: isMobile ? '340px' : '500px',
                height: isMobile ? '200px' : '280px',
                position: 'relative',
                perspective: '1000px',
                cursor: 'pointer'
            }}
        >
            {
                <Box
                    onClick={e => {
                        setIsFlipped(!isFlipped)
                    }}
                    sx={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        textAlign: 'center',
                        transition: 'transform 0.6s',
                        transformStyle: 'preserve-3d',
                        transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                    }}
                >
                    {/* Back Face */}
                    <Paper
                        elevation={3}
                        sx={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backfaceVisibility: 'hidden',
                            transform: 'rotateY(180deg)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <Box
                            sx={{
                                zIndex: 1,
                                color: 'white',
                                width: '100%',
                                paddingLeft: isMobile ? '14px' : '40px',
                                paddingRight: isMobile ? '24px' : '40px',
                                backgroundImage: `url(${gradient})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                height: '100%',
                                backgroundPositionX: 'center',
                                backgroundPositionY: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography
                                component='div'
                                sx={{
                                    mb: isMobile ? 11 : 10,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    fontSize: isMobile ? '0.9rem' : '19px',
                                    color: theme.palette.primary.main,
                                    lineHeight: 1.8,
                                    textAlign: 'left'
                                }}
                            >
                                {`${specialty}`}
                                <br />
                                {`${institution}`}
                                <br />
                                {`${email}`}
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }} />
                            <Box
                                component='img'
                                src={transparentWave}
                                alt='transparent wave'
                                sx={{
                                    position: 'absolute',
                                    top: 14,
                                    left: 0,
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                }}
                            >

                            </Box>
                                <Box
                                    component='img'
                                    src={Logo}
                                    alt='transparent wave'
                                    sx={{
                                        position: 'absolute',
                                        top: isMobile ? 140 : 350,
                                        left: isMobile ? 240 : 350,
                                        width: '25%',
                                        height: 'auto',
                                        display: 'block',
                                        zIndex: 0,
                                    }}
                                >
                                </Box>
                        </Box>
                        
                    </Paper>

                    {/* Front Face */}
                    <Paper
                        elevation={3}
                        sx={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backfaceVisibility: 'hidden',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                top: 0,
                                zIndex: 1,
                                paddingLeft: isMobile ? '24px' : '40px',
                                paddingRight: isMobile ? '24px' : '40px',
                                backgroundImage: `url(${gradient})`,
                                backgroundSize: 'cover',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                textAlign: 'left'
                            }}
                        >
                            <Box
                                component='img'
                                src={bctLogoWhite}
                                alt='Breast Cancer Trials logo'
                                sx={{
                                    position: 'absolute',
                                    top: 15,
                                right: isMobile ? 12 : 20,
                                width: '40%',
                                height: '20%',
                                display: 'block',
                                zIndex: 0,
                                objectFit: 'contain',
                                }}
                            />

                            {/* Name Content */}
                            <Typography
                                component='div'
                                fontWeight={700}
                                sx={{
                                    textTransform: 'uppercase',
                                    fontSize: isMobile ? '1.125rem' : '30px',
                                    pb: isMobile ? 3 : 5,
                                    mt: isMobile ? 1 : 1,
                                    color: theme.palette.primary.main,
                                    zIndex: 2,
                                    position: 'relative'
                                }}
                            >
                                {`${title} ${firstName}`} <br/>  {lastName}
                            </Typography>

                            <Box
                                component='img'
                                src={transparentWave}
                                alt='transparent wave'
                                sx={{
                                    position: 'absolute',
                                    top: 30,
                                    left: 0,
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                }}
                            >
                            </Box>
                        </Box>

                    </Paper>
                </Box>
            }
        </Box>
    )
}

export default BusinessCard
